// extracted by mini-css-extract-plugin
module.exports = {"CourseBuildCompletionBtn":"AddNationalStudygroup_CourseBuildCompletionBtn__870sD"};